import React, { PureComponent, Fragment } from 'react';
import { connect } from 'react-redux';
import _filter from 'lodash/filter';
import AutosizeInput from 'react-input-autosize';
import dayjs from 'dayjs';
import ResponsiveImage from '../../shared/responsiveImage';
import { strCount } from '../../../helpers/stringutils';

class MastheadCyoa extends PureComponent {

  constructor(props){
    super(props);
    this.startAgainClicked = this.startAgainClicked.bind(this);
    this.onShareModal = this.onShareModal.bind(this);
  }

  onShareModal(){ this.props.openShareModal(); }


  startAgainClicked(){
    window.location.href = `${process.env.REACT_APP_WWW_DISCOVERY_URL}${process.env.REACT_APP_DISCOVER_PAGE}`;
  }


  updateInputValue = (input, event) => {
		const newState = {};
		newState[input] = event.target.value;
		this.setState(newState);
	};


  render(){


    const { itineraries:{content:{cyoa_name, date_start, date_end}, sectors, cities}  } = this.props;
    let imageLink = "";
    try{
      imageLink =  _filter( cities[0].images, ['title', 'hero'])[0].url;
    }catch(e){
    }


    return (
      <Fragment>
        <div className="cyao-masthead" id="cyao-masthead">
          <div className="cyao-masthead-image">
             <ResponsiveImage src={imageLink} width={698} widthRetina={1200} alt={sectors[0].name} quality={70} />
          </div>
          <div className="cyao-masthead-content">

            <div className="button-wrapper">
              <button type="button" className="start-button margin-b-10" onClick={this.startAgainClicked}>
                <span className="arrow orange-text">&larr;</span>
                Start Again
              </button>
            </div>

          <div className="signpost">
            <div className="button-wrapper start">

                <AutosizeInput
        					value={cyoa_name}
        					onChange={this.updateInputValue.bind(this, 'tourname')}
                  className={`tourname-text no-margin ${strCount(cyoa_name, 17, "small", true)}`}
        				/>

            </div>

            <div className="button-wrapper date">
              <button type="button" className="date-button" onClick={() => this.props.openItineraryModal('calendar')}>
                <svg className="calendar-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                  <path d="M148 288h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm108-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 96v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm192 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96-260v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"/>
                </svg>
                {  dayjs(date_start).format('DD MMMM') } &nbsp;
                &rarr;
                &nbsp; { dayjs(date_end).format('DD MMMM YYYY') }
              </button>
              <button className="share-button" type="button" onClick={this.onShareModal}>

                <svg xmlns="http://www.w3.org/2000/svg" width="77.598" height="57.736" viewBox="0 0 77.598 57.736">
                  <g data-name="Layer 2">
                    <g data-name="Layer 1">
                      <path d="M22.53 19.968a2 2 0 0 1-2-2 12.915 12.915 0 0 1 12.899-12.9c.354 0 .705.015 1.052.042a11.337 11.337 0 0 1 4.662 1.41 2 2 0 1 1-1.957 3.489 7.356 7.356 0 0 0-3.026-.911 9.456 9.456 0 0 0-.731-.03 8.91 8.91 0 0 0-8.9 8.9 2 2 0 0 1-2 2zM31.907 34.69a2 2 0 0 1-1.435-3.393l4.237-4.37a2 2 0 0 1 2.871 2.785l-4.237 4.37a1.994 1.994 0 0 1-1.436.608z"/>
                      <path d="M13.177 34.69a1.995 1.995 0 0 1-1.469-.642l-1.627-1.759-6.598-6.963A12.26 12.26 0 0 1 1.117 11.71a11.487 11.487 0 0 1 9.48-6.599c.35-.028.702-.043 1.056-.043a12.915 12.915 0 0 1 12.9 12.9 2 2 0 1 1-4 0 8.91 8.91 0 0 0-8.9-8.9c-.247 0-.493.011-.736.03a7.527 7.527 0 0 0-6.194 4.342 8.24 8.24 0 0 0 1.663 9.134l8.257 8.757a2 2 0 0 1-1.467 3.358zM22.53 44.267a1.994 1.994 0 0 1-1.415-.586l-4.556-4.558a2 2 0 0 1 2.828-2.828l4.556 4.557a2 2 0 0 1-1.414 3.415z"/>
                      <path d="M22.554 44.267a2 2 0 0 1-1.414-3.415l4.557-4.557a2 2 0 0 1 2.828 2.828l-4.557 4.558a1.994 1.994 0 0 1-1.414.586zM51.781 39.617A19.809 19.809 0 1 1 71.59 19.81 19.81 19.81 0 0 1 51.78 39.617zm0-35.617A15.809 15.809 0 1 0 67.59 19.809 15.766 15.766 0 0 0 51.78 4z"/>
                      <path d="M51.68 31.59a10.118 10.118 0 0 1-9.595-6.934 2 2 0 1 1 3.793-1.27 6.107 6.107 0 0 0 11.755-.535 2 2 0 0 1 3.895.91 10.208 10.208 0 0 1-9.848 7.829zM75.525 57.736H28.036a2 2 0 0 1-1.955-1.577c-.578-2.672 1.02-6.931 3.979-10.6 2.902-3.598 9.582-9.632 21.72-9.632s18.82 6.036 21.722 9.633c2.958 3.668 4.557 7.928 3.978 10.6a2 2 0 0 1-1.955 1.576zm-45.379-4h43.27a15.546 15.546 0 0 0-3.027-5.665c-2.453-3.04-8.133-8.143-18.609-8.143s-16.154 5.101-18.606 8.143a15.552 15.552 0 0 0-3.027 5.665zM22.53 19.968a2 2 0 0 1-2-2 12.915 12.915 0 0 1 12.899-12.9c.354 0 .705.015 1.052.042a11.337 11.337 0 0 1 4.662 1.41 2 2 0 1 1-1.957 3.489 7.356 7.356 0 0 0-3.026-.911 9.456 9.456 0 0 0-.731-.03 8.91 8.91 0 0 0-8.9 8.9 2 2 0 0 1-2 2zM31.907 34.69a2 2 0 0 1-1.435-3.393l4.237-4.37a2 2 0 0 1 2.871 2.785l-4.237 4.37a1.994 1.994 0 0 1-1.436.608z"/>
                      <path d="M13.177 34.69a1.995 1.995 0 0 1-1.469-.642l-1.627-1.759-6.598-6.963A12.26 12.26 0 0 1 1.117 11.71a11.487 11.487 0 0 1 9.48-6.599c.35-.028.702-.043 1.056-.043a12.915 12.915 0 0 1 12.9 12.9 2 2 0 1 1-4 0 8.91 8.91 0 0 0-8.9-8.9c-.247 0-.493.011-.736.03a7.527 7.527 0 0 0-6.194 4.342 8.24 8.24 0 0 0 1.663 9.134l8.257 8.757a2 2 0 0 1-1.467 3.358zM22.53 44.267a1.994 1.994 0 0 1-1.415-.586l-4.556-4.558a2 2 0 0 1 2.828-2.828l4.556 4.557a2 2 0 0 1-1.414 3.415z"/>
                      <path d="M22.554 44.267a2 2 0 0 1-1.414-3.415l4.557-4.557a2 2 0 0 1 2.828 2.828l-4.557 4.558a1.994 1.994 0 0 1-1.414.586zM51.781 39.617A19.809 19.809 0 1 1 71.59 19.81 19.81 19.81 0 0 1 51.78 39.617zm0-35.617A15.809 15.809 0 1 0 67.59 19.809 15.766 15.766 0 0 0 51.78 4z"/>
                      <path d="M51.68 31.59a10.118 10.118 0 0 1-9.595-6.934 2 2 0 1 1 3.793-1.27 6.107 6.107 0 0 0 11.755-.535 2 2 0 0 1 3.895.91 10.208 10.208 0 0 1-9.848 7.829zM75.525 57.736H28.036a2 2 0 0 1-1.955-1.577c-.578-2.672 1.02-6.931 3.979-10.6 2.902-3.598 9.582-9.632 21.72-9.632s18.82 6.036 21.722 9.633c2.958 3.668 4.557 7.928 3.978 10.6a2 2 0 0 1-1.955 1.576zm-45.379-4h43.27a15.546 15.546 0 0 0-3.027-5.665c-2.453-3.04-8.133-8.143-18.609-8.143s-16.154 5.101-18.606 8.143a15.552 15.552 0 0 0-3.027 5.665z"/>
                    </g>
                  </g>
                </svg>

                Share
              </button>
            </div>
          </div>


          </div>
        </div>


      </Fragment>
    )
  }
}




function mapStateToProps(state){
  return {
    itineraries:state.itineraries.data
  }
}

export default connect(mapStateToProps, null)(MastheadCyoa);



// WEBPACK FOOTER //
// ./src/components/itinerary/components/masthead-cyoa.js